import { PagedData } from "@/services/models/shared/PagedData";
import { AxiosResponse } from "axios";
import {
  FAMISDBTitleFilterOptions,
  FAMISDBTitleListItem,
  UpdateFAMISDBTitle
} from "@/services/models/FAMISDBTitle";
import BimsHttpService from "@/services/BimsHttpService";

class FAMISDBTitlesService {
  /**
   * @description Returns a paged list of FAMISDB Titles
   */
  getFAMISDBTitles(
    filter: FAMISDBTitleFilterOptions
  ): Promise<PagedData<FAMISDBTitleListItem>> {
    return BimsHttpService.get(`/FAMISDBTitles`, {
      params: filter,
    }).then((response: AxiosResponse<PagedData<FAMISDBTitleListItem>>) => {
      return response.data as PagedData<FAMISDBTitleListItem>;
    });
  }

  /**
 * @description Updates the FAMISDB title
 */
  updateFAMISDBTitle(title: UpdateFAMISDBTitle): Promise<any> {
    return BimsHttpService.put(`/FAMISDBTitles`, title);
  }
}

export default new FAMISDBTitlesService();
